import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getTeachers } from "../ApiService/ApiService";

export const fetchTeachersAsync = createAsyncThunk(
  "teachers/fetchTeachers",
  async () => {
    const response = await getTeachers();
    return response.data;
  }
);

const initialState = {
  teachers: [],
  loading: false,
  error: null,
};

export const teachersSlice = createSlice({
  name: "teachers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeachersAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeachersAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.teachers = action.payload; 
      })
      .addCase(fetchTeachersAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const selectAllTeachers = (state) => state.teachers.teachers;
export const selectTeachersLoading = (state) => state.teachers.loading;
export const selectTeachersError = (state) => state.teachers.error;

export default teachersSlice.reducer;
